import modelResultFactory from "./ModelResult";
import ResultCalendar from "~/ui/components/ResultCalendar/ResultCalendar";

export default modelResultFactory({ ResultComponent: ResultCalendar });